import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

function navCta(mode) {
  if (mode === "tickets_live") return "Get tickets";
  if (mode === "waitlist") return "Join the waitlist";
  return "Join Early Access";
}

export default function Nav({ settings }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "nav-solid" : "nav-ghost"
      }`}
    >
      <div
        className={`hero-wide flex items-center justify-between transition-all duration-300 ${
          scrolled ? "h-[64px]" : "h-[72px] md:h-[76px] lg:h-[84px]"
        }`}
      >
        <a
          href="#top"
          onClick={scrollTo("top")}
          className="flex items-center gap-3"
          data-testid="nav-logo"
          aria-label="Norwegian AI Summit — home"
        >
          <span className="wordmark">
            <span className="wordmark__bold">Norwegian</span>
            <span className="wordmark__light hidden min-[430px]:inline">AI Summit</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9 lg:gap-11">
          <a
            href="#speakers"
            onClick={scrollTo("speakers")}
            className="nav-link"
            data-testid="nav-speakers"
          >
            Speakers
          </a>
          <a
            href="#program"
            onClick={scrollTo("program")}
            className="nav-link"
            data-testid="nav-program"
          >
            Program
          </a>
          <a
            href="#partners"
            onClick={scrollTo("partners")}
            className="nav-link"
            data-testid="nav-partners"
          >
            Partners
          </a>
          <a
            href="#venue"
            onClick={scrollTo("venue")}
            className="nav-link"
            data-testid="nav-venue"
          >
            Venue
          </a>
        </nav>

        <a
          href="#early-access"
          onClick={scrollTo("early-access")}
          className="btn-accent btn-accent--sm"
          data-testid="nav-cta"
        >
          {navCta(settings?.mode)}
          <ArrowRight size={14} strokeWidth={2} className="arrow" />
        </a>
      </div>
    </header>
  );
}
